// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Rewards_wrapper__3tRs8"};